import axios from '../../axios/index.js'

export default {
    getCatalog(params){
      return axios.get('ehs_catalog/catalogs',{params:params})
    },
    getFrequencies(){
      return axios.get('ehs_catalog/getFrequencies')
    },
    list (data) {
      return axios.post('ehs_catalog/list',data)
    },
    store (data){
      return axios.post('ehs_catalog/store',data)
    },
    update(data) {
      return axios.post('ehs_catalog/update',data)
    },
    delete(id) {
      return axios.delete('ehs_catalog/delete',{ params: { id } })
    }
}
  